import React from "react";
import BottomSheetDT from '@React_UI_Lib/BottomSheetDT'
import * as S from './PolicyPageMmtStyles'

const PolicyPageMmt = ({policyDetails = {}, closeModal}) => {

  return (
    <div className="policy__container">
      <BottomSheetDT
        onModalClose={closeModal}
        isPWA={true}
        customClass=""
        showBackdrop={true}
        outsideClosable={true}
        height="80%"
      >
        <S.PolicyHeader>
          <S.HeaderText>{policyDetails?.title}</S.HeaderText>
        </S.PolicyHeader>
        <S.PolicyList>
          {
            policyDetails?.data?.map((policy) => 
              <div key={policy.idx} className="policy__row">
                <S.PolicyTitle>{policy.title}</S.PolicyTitle>
                {policy?.content?.map((contentData, index) => (
                  <S.PolicyDescp key={index}>{contentData}</S.PolicyDescp>
                ))}
              </div>
            )
          }
        </S.PolicyList>
      </BottomSheetDT>
    </div>
  )
}

export default PolicyPageMmt